import React from 'react';
import { Field, useField } from 'formik';
import CustomDateField from './temp/CustomDateField';

export const ReportDatePicker = ({ name, label, validate, ...props }) => {
  const [field, meta] = useField(name)

  return (
    <Field
      component={CustomDateField}
      name={name}
      label={label}
      value={field.value ?? ''}
      validate={validate}
      meta={meta}
      {...props}
    />
  );
}
